'use strict';
define(['app', 'angular'], function (app, angular) {
    app.factory('SuiteNavigation', ['$document', '$rootScope', '$timeout', function ($document, $rootScope, $timeout) {
        var state = {open: false};
        var previousFocus;
        function close() {
            if (!state.open) { return; }
            state.open = false;
            if (previousFocus && previousFocus.isConnected) { previousFocus.focus(); }
        }
        function toggle() {
            if (state.open) { close(); return; }
            previousFocus = $document[0].activeElement;
            state.open = true;
            $timeout(function () {
                var first = $document[0].querySelector('#side-navbar a');
                if (first) { first.focus(); }
            });
        }
        $document.on('keydown', function (event) {
            if (!state.open) { return; }
            if (event.key === 'Escape') {
                $rootScope.$applyAsync(close);
                event.preventDefault();
            } else if (event.key === 'Tab') {
                var items = Array.prototype.filter.call($document[0].querySelectorAll('#side-navbar a, #side-navbar button, #side-navbar summary, #side-navbar select'), function (item) {
                    return !item.disabled && item.offsetParent !== null;
                });
                var first = items[0];
                var last = items[items.length - 1];
                if (event.shiftKey && $document[0].activeElement === first) { event.preventDefault(); last.focus(); }
                if (!event.shiftKey && $document[0].activeElement === last) { event.preventDefault(); first.focus(); }
            }
        });
        return {state: state, toggle: toggle, close: close};
    }]);
});
